module.exports = __webpack_public_path__ + "static/media/logo_red.6c6c6a4a.png";